const THOUSAND_MILI_SECONDS = 1000;

export { THOUSAND_MILI_SECONDS };
